import { render, staticRenderFns } from "./InnerScrollCard.vue?vue&type=template&id=f613eab0&scoped=true&"
import script from "./InnerScrollCard.vue?vue&type=script&lang=ts&"
export * from "./InnerScrollCard.vue?vue&type=script&lang=ts&"
import style0 from "./InnerScrollCard.vue?vue&type=style&index=0&id=f613eab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f613eab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
